import Model  from '@/util/models';

export default class Site extends Model { 
    backend = '/site/'; 
   
    test(){                        
        return this.api.get(this.backend + 'test'); 
    }        
}

